import React from 'react';
import { colors, Text } from '../../../globalStyles';
import { GetSaiSurveysForOrgQuery } from '../../../graphQL';

type SurveyType = GetSaiSurveysForOrgQuery['getSaiSurveysForOrg'][number];

interface SurveyPeriodDisplayProps {
  surveyPeriod: SurveyType;
}

export const SurveyPeriodDisplay = ({ surveyPeriod }: SurveyPeriodDisplayProps): JSX.Element => {
  if (!surveyPeriod) return <></>;

  return (
    <div className="p3" style={{ backgroundColor: colors.white, borderRadius: 4 }}>
      <Text.bodyBold>{surveyPeriod.name}</Text.bodyBold>
      <div className="mt2">
        <Text.bodySmall>
          <strong>Survey Display Name:</strong> {surveyPeriod.name}
        </Text.bodySmall>
        <Text.bodySmall>
          <strong>Start Date:</strong> {surveyPeriod.startDate}
        </Text.bodySmall>
        <Text.bodySmall>
          <strong>End Date:</strong> {surveyPeriod.endDate}
        </Text.bodySmall>
        <Text.bodySmall>
          <strong>Term:</strong> {surveyPeriod.term}
        </Text.bodySmall>
        <Text.bodySmall>
          <strong>Version:</strong> {surveyPeriod.assessmentKey}
        </Text.bodySmall>
        <Text.bodySmall>
          <strong>Academic Year:</strong>{' '}
          {`${surveyPeriod.academicYearStart}-${surveyPeriod.academicYearEnd}`}
        </Text.bodySmall>
        <Text.bodySmall>
          <strong>Calendar Year:</strong> {surveyPeriod.calendarYear}
        </Text.bodySmall>
      </div>
    </div>
  );
};
